fx.asset({

    box_classique_square : "/app/assets/images/print/box-classic-square.png",
    box_classique_rectangle : "/app/assets/images/print/box-classic-rectangle.png",

    box_liberty_square : "/app/assets/images/print/box-liberty-square.png",
    box_liberty_rectangle : "/app/assets/images/print/box-liberty-rectangle.png",

    box_monster_square : "/app/assets/images/print/box-monster-square.png",
    box_monster_rectangle : "/app/assets/images/print/box-monster-rectangle.png",

    box_voyage_square : "/app/assets/images/print/box-travel-square.png",
    box_voyage_rectangle : "/app/assets/images/print/box-travel-rectangle.png",

});